import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import nintexHeaderImage from '../assets/nintex-header.svg';
import sharepointIntegrationImage from '../assets/sharepoint-integration.svg';
import sharepointOnlineIntegrationImage from '../assets/sharepoint-online-integrations.svg';

const SetupNwcIntegration = () => {
    const { t } = useTranslation();

    return (
        <div>
            <p><Trans i18nKey="setupNwcIntegration.note" /></p>
            <p><Trans i18nKey="setupNwcIntegration.begin" /></p>
            <p><Trans i18nKey="setupNwcIntegration.step1" /></p>
            <p><Trans i18nKey="setupNwcIntegration.step2" /></p>
            <p><img src={nintexHeaderImage} alt={t('setupNwcIntegration.nintexHeaderAltText')} /></p>
            <p><Trans i18nKey="setupNwcIntegration.step3" /></p>
            <p><img src={sharepointIntegrationImage} alt={t('setupNwcIntegration.sharePointIntegrationAltText')} /></p>
            <p><Trans i18nKey="setupNwcIntegration.step4" /></p>
            <p><img src={sharepointOnlineIntegrationImage} alt={t('setupNwcIntegration.spoIntegrationAltText')} /></p>
            <p><Trans i18nKey="setupNwcIntegration.step5" /></p>
            <p><Trans i18nKey="setupNwcIntegration.step6" /></p>
            <p>{t('setupNwcIntegration.footnote')}</p>
        </div>
    );
};

export default SetupNwcIntegration;